export enum OffsiteCampaignStatus {
  Draft = 'DRAFT',
  Active = 'ACTIVE',
  InActive = 'INACTIVE',
  Deleted = 'DELETED',
  Testing = 'TESTING',
  Migration = 'MIGRATION',
  Finished = 'FINISHED',
  Live = 'LIVE',
  Scheduled = 'SCHEDULED',
  Triggered = 'TRIGGERED',
}

export type State = 'ACTIVE' | 'INACTIVE' | 'DELETED' | 'TESTING' | 'MIGRATION' | 'SCHEDULED' | 'FINISHED';

export interface LifeCycle {
  state?: OffsiteCampaignStatus;
  startTime?: number | null;
  endTime?: number | null;
}
